import { html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map';

import { TeInputComponent } from './te-input-component';

type InputTypeVariant = 'text' | 'password';

/** Input Password Component */

@customElement('te-input-password')
export class TeInputPassword extends TeInputComponent {
  static styles = [
    ...TeInputComponent.styles,
    css`
      te-icon {
        cursor: pointer;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 40px;
        right: 0;
        top: 0;
      }

      input[type='password'] {
        font-size: 20px;
        letter-spacing: 2px;
      }
    `,
  ];

  @state() type: InputTypeVariant = 'password';

  onEyeIconClick() {
    this.type = this.type === 'password' ? 'text' : 'password';
  }

  render() {
    const { type } = this;
    return html`
      <div class="wrapper">
        <div class="te-input" style=${styleMap(this.getWrapperStyle())}>
          ${this.renderLabel()}${this.renderInput(type, true)}
          <te-icon
            name=${type === 'password' ? 'eye-show' : 'eye-hide'}
            size="16"
            @click=${this.onEyeIconClick}
            class="eye-icon"
          ></te-icon>
          ${this.renderLoader()}
        </div>
        ${this.renderCharCount()} ${this.renderError()}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-input-password': TeInputPassword;
  }
}
